const HOUR_IN_MS = 3_600_000;
/**
 * Computes time to next full hour in milliseconds.
 * @returns Milliseconds to the next hour
 */
export const getMilliSecondsToNextHour = () => {
	return HOUR_IN_MS - (new Date().getTime() % HOUR_IN_MS);
};
